<template>
    <div class="dd-m-auth dd-m-auth--register">
        <div class="dd-m-auth__content">
            <h2 class="dd-m-auth__title">Redefine password</h2>

            <div class="dd-m-auth__form">
                <form class="dd-m-form dd-m-form--login dd-m-form--auth"
                      novalidate v-on:submit.prevent="reset()">
                    <div class="dd-m-form__row">
                        <div class="dd-m-form__col"
                             v-bind:class="{'has-error' : fields.password && !fields.password.valid &&
                             fields.password.touched && !user.password.errors.length,
                             'is-validated' : fields.password && fields.password.valid && fields.password.touched &&
                             !user.password.errors.length}">
                            <input name="password"
                                   type="password"
                                   required
                                   v-model="user.password.value"
                                   v-validate="'required'"
                                   v-on:focus="user.password.errors = []"
                                   placeholder="Senha"
                                   class="dd-m-form__input dd-m-form__input--bordered"/>

                            <div class="dd-m-form__error-msg" v-if="user.password.errors.length">
                                {{user.password.errors[0]}}
                            </div>
                        </div>
                    </div>

                    <div class="dd-m-form__row">
                        <div class="dd-m-form__col"
                             v-bind:class="{'has-error' : fields.confirm_password && !fields.confirm_password.valid &&
                             fields.confirm_password.touched && !user.password_confirmation.errors.length,
                             'is-validated' : fields.confirm_password && fields.confirm_password.valid && fields.confirm_password.touched &&
                             !user.password_confirmation.errors.length}">
                            <input name="confirm_password"
                                   type="password"
                                   required
                                   v-model="user.password_confirmation.value"
                                   v-validate="{is: user.password.value, required: true}"
                                   v-on:focus="user.password_confirmation.errors = []"
                                   placeholder="Confirmar senha"
                                   class="dd-m-form__input dd-m-form__input--bordered"/>

                            <div class="dd-m-form__error-msg" v-if="user.password_confirmation.errors.length">
                                {{user.password_confirmation.errors[0]}}
                            </div>
                        </div>
                    </div>

                    <div class="dd-m-alert dd-m-alert--danger" v-if="error">
                        <span>
                            {{error}}
                        </span>
                    </div>

                    <div class="dd-m-form__row">
                        <div class="dd-m-form__col">
                            <vue-ladda
                                    button-class="dd-m-form__submit dd-m-button dd-m-button--default dd-m-button--assertive"
                                    :loading="loading">
                                Redefinir
                            </vue-ladda>
                        </div>
                    </div>

                    <div class="dd-m-form--auth__actions">
                        <button v-on:click.prevent="toggle()" type="button"
                                class="dd-m-form--auth__btn dd-m-form--auth__login-btn">
                            Já possui uma conta? Conecte-se
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import AuthService from '../../providers/api/auth-service';

    const api = new AuthService();

    export default {
        name: 'auth-reset-password',
        props: ['token'],
        data: () => {
            return {
                loading: false,
                error: null,
                user: {
                    password: {
                        value: null,
                        errors: []
                    },
                    password_confirmation: {
                        value: null,
                        errors: []
                    }
                }
            }
        },
        mounted() {
        },
        methods: {
            toggle() {
                PubSub.publish('openLoginModal');
                setTimeout(() => {
                    PubSub.publish('closeRecoveryModal');
                    window.history.pushState(null, null, window.location.pathname);
                    // Remove o parâmetro de token da URL sem dar reload na página
                }, 100);
            },
            reset() {
                if (this.user.password.value && this.user.password_confirmation.value) {
                    this.loading = true;
                    this.error = null;

                    const params = {
                        "password": this.user.password.value,
                        "password_confirmation": this.user.password_confirmation.value,
                        "token": this.token
                    };

                    api.doResetPassword(params)
                        .then(() => {
                            this.loading = false;
                            this.toggle()
                        })
                        .catch((err) => {

                            this.loading = false;
                            if (err.response && err.response.status === 422) {
                                const errValidations = err.response.data.error.validations;
                                for (const j in errValidations) {
                                    if (errValidations.hasOwnProperty(j) && this.user[j]) {
                                        this.user[j].errors = errValidations[j];
                                    }
                                }

                                if (!errValidations) {
                                    this.error = err.response.data.error.message;
                                }
                            }

                            this.loading = false;
                        });
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/auth/auth-reset-password.vue